import { render, staticRenderFns } from "./ware.vue?vue&type=template&id=48403d8a&scoped=true&"
import script from "./ware.vue?vue&type=script&lang=js&"
export * from "./ware.vue?vue&type=script&lang=js&"
import style0 from "./ware.vue?vue&type=style&index=0&id=48403d8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48403d8a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default})
